import { createFileRoute } from "@tanstack/react-router";
import { LocalBookingsPage } from "../../../features/account";

export const Route = createFileRoute("/$lang/_layout/bookings/")({
  component: LocalBookingsPage,
});
